import ErrorIcon from '@mui/icons-material/ErrorRounded';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';

interface Props {
  onMount: () => void;
}

export function FailedToLoadPresetContent({ onMount }: Props) {
  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ErrorIcon sx={{ width: 48, height: 48 }} color="error" />
      <Typography color="error">
        Unable to get shared preset. Please try again later
      </Typography>
    </Box>
  );
}
